import React from 'react';
import { Avatar } from '../ui/Avatar';
import { Button } from '../ui/Button';
import { Phone, Video, MoreVertical, ArrowLeft } from 'lucide-react';
interface ChatHeaderProps {
  name: string;
  handle: string;
  avatar: string;
  isOnline: boolean;
  onBack?: () => void;
}
export function ChatHeader({
  name,
  handle,
  avatar,
  isOnline,
  onBack
}: ChatHeaderProps) {
  return <div className="h-16 border-b bg-white flex items-center justify-between px-4 sticky top-0 z-10" data-id="element-82">
      <div className="flex items-center" data-id="element-83">
        {onBack && <Button variant="ghost" size="sm" className="mr-2 md:hidden" onClick={onBack} data-id="element-84">
            <ArrowLeft className="h-5 w-5" data-id="element-85" />
          </Button>}
        <Avatar src={avatar} alt={name} isOnline={isOnline} size="md" data-id="element-86" />
        <div className="ml-3" data-id="element-87">
          <h3 className="text-sm font-semibold text-gray-900" data-id="element-88">{name}</h3>
          <p className="text-xs text-muted-foreground" data-id="element-89">
            {isOnline ? 'Active now' : `@${handle}`}
          </p>
        </div>
      </div>
      <div className="flex items-center space-x-1" data-id="element-90">
        <Button variant="ghost" size="sm" className="text-gray-500" data-id="element-91">
          <Phone className="h-4 w-4" data-id="element-92" />
        </Button>
        <Button variant="ghost" size="sm" className="text-gray-500" data-id="element-93">
          <Video className="h-4 w-4" data-id="element-94" />
        </Button>
        <Button variant="ghost" size="sm" className="text-gray-500" data-id="element-95">
          <MoreVertical className="h-4 w-4" data-id="element-96" />
        </Button>
      </div>
    </div>;
}